import { render, staticRenderFns } from "./choseRole.vue?vue&type=template&id=0555e6bf&scoped=true&"
import script from "./choseRole.vue?vue&type=script&lang=js&"
export * from "./choseRole.vue?vue&type=script&lang=js&"
import style0 from "./choseRole.vue?vue&type=style&index=0&id=0555e6bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555e6bf",
  null
  
)

export default component.exports